import { useCallback, useMemo } from 'react';
import { useMeQuery, useUpdatePreferencesMutation } from '@platform/state/api';
import { useAppDispatch, useAppSelector } from '@platform/state/hooks';
import { selectSession } from '@platform/state/selectors';
import { colorSchemeChanged } from '@platform/state/slices/sessionSlice';
import type { IColorSchemeApi } from './IColorSchemeApi';
import { applyColorScheme } from './applyColorScheme';
import { COLOR_SCHEMES } from './colorSchemes';
import { findColorScheme } from './findColorScheme';

/**
 * Поточна колірна схема користувача і її зміна: документ (data-scheme/data-mode), сесія Redux (persistence → localStorage),
 * сервер — налаштування colorScheme через PUT /me/preferences (разом із мовою і закріпленими модулями), резерв у localStorage.
 */
export function useColorScheme(): IColorSchemeApi {
  const dispatch = useAppDispatch();
  const session = useAppSelector(selectSession);
  const { data: me } = useMeQuery();
  const [update] = useUpdatePreferencesMutation();
  const scheme = useMemo(() => findColorScheme(session.colorScheme), [session.colorScheme]);
  const setScheme = useCallback((id: string) => {
    const next = applyColorScheme(id);
    dispatch(colorSchemeChanged(next.id));
    if (me) void update({ locale: session.lang, colorScheme: next.id, pinnedModules: me.pinnedModules });
  }, [dispatch, me, session.lang, update]);
  return { scheme, schemes: COLOR_SCHEMES, setScheme };
}
